import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { rightsizingRecommendationsDataSelector } from "./rightsizingRecommendationsDataSelector";

export const rightsizingRecommendationsDataTotalLengthSelector =
  createDraftSafeSelector(
    [rightsizingRecommendationsDataSelector],
    (data) => data?.length ?? 0,
  );
